module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-metals.64536b67.png";